import { ukSizes } from '../../../domain/sizes';

type Props = {
  selectedSizes: string[];
  setSelectedSizes: React.Dispatch<string[]>;
};

export const SIZE_GRID_ALL = 'ALL';

const sizeItemClassNames = 'text-center py-2 rounded cursor-pointer';

export default function SizeGrid({ selectedSizes, setSelectedSizes }: Props) {
  function onClick(value: string) {
    if (value === SIZE_GRID_ALL) {
      setSelectedSizes([value]);
    } else if (selectedSizes.includes(value)) {
      setSelectedSizes(selectedSizes.filter((v) => v !== value));

      if (selectedSizes.length < 2) setSelectedSizes([SIZE_GRID_ALL]);
    } else {
      setSelectedSizes(
        [...selectedSizes, value].filter((v) => v !== SIZE_GRID_ALL)
      );
    }
  }

  const selectedClassNames = 'bg-forest text-white';
  const unselectedClassNames = 'bg-concrete text-black';

  return (
    <>
      <input
        type="button"
        name="all"
        className={`${sizeItemClassNames} ${
          selectedSizes.includes(SIZE_GRID_ALL)
            ? selectedClassNames
            : unselectedClassNames
        }`}
        onClick={() => onClick(SIZE_GRID_ALL)}
        value="All"
      />
      {ukSizes.map((size) => (
        <input
          type="button"
          name={`size_${size}`}
          key={size}
          className={`${sizeItemClassNames} ${
            selectedSizes.includes(size)
              ? selectedClassNames
              : unselectedClassNames
          } rounded`}
          onClick={() => onClick(size)}
          value={size}
        />
      ))}
    </>
  );
}
